// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_PainelResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * GET /rede/painel — a visão geral da rede (Full; chamado NS 2026-0082). País e UF contam só as
 * unidades ativas e em onboarding.
 */
import type { Rede_AnoRow } from './Rede_AnoRow'
import type { Rede_ContagemRow } from './Rede_ContagemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Rede_PainelResponseDados {
total: number
totais: Rede_ContagemRow[]
por_pais: Rede_ContagemRow[]
por_uf: Rede_ContagemRow[]
inauguracoes_por_ano: Rede_AnoRow[]
encerramentos_por_ano: Rede_AnoRow[]
repasses_por_ano: Rede_AnoRow[]
contratos_vencidos: number
contratos_vencendo: number
encerramentos_a_conferir: number
encerramentos_para_casar: number
}

export type Rede_PainelResponse = ApiResponse<Rede_PainelResponseDados>;

registerResponseContract('Rede_PainelResponse', {
  total:                    { type: 'number',  required: true },
  totais: {
    type: 'array',
    required: true,
    items: {
      chave:  { type: 'string',  required: true },
      rotulo: { type: 'string',  required: false },
      total:  { type: 'number',  required: false },
    },
  },
  por_pais: {
    type: 'array',
    required: true,
    items: {
      chave:  { type: 'string',  required: true },
      rotulo: { type: 'string',  required: false },
      total:  { type: 'number',  required: false },
    },
  },
  por_uf: {
    type: 'array',
    required: true,
    items: {
      chave:  { type: 'string',  required: true },
      rotulo: { type: 'string',  required: false },
      total:  { type: 'number',  required: false },
    },
  },
  inauguracoes_por_ano: {
    type: 'array',
    required: true,
    items: {
      ano:   { type: 'number',  required: true },
      total: { type: 'number',  required: false },
    },
  },
  encerramentos_por_ano: {
    type: 'array',
    required: true,
    items: {
      ano:   { type: 'number',  required: true },
      total: { type: 'number',  required: false },
    },
  },
  repasses_por_ano: {
    type: 'array',
    required: true,
    items: {
      ano:   { type: 'number',  required: true },
      total: { type: 'number',  required: false },
    },
  },
  contratos_vencidos:       { type: 'number',  required: true },
  contratos_vencendo:       { type: 'number',  required: true },
  encerramentos_a_conferir: { type: 'number',  required: true },
  encerramentos_para_casar: { type: 'number',  required: true },
})
